import { type TActiveExperiment as TApiActiveExperiment } from '@core/api'

import { type TActiveExperiment } from '@core/models'

export const convertActiveExperiment = (
    apiActiveExperiment: TApiActiveExperiment,
): TActiveExperiment => {
    const { id, member, slug, variation, date_start, date_end } = apiActiveExperiment

    return {
        id,
        member,
        slug,
        variation,
        dateStart: date_start,
        dateEnd: date_end,
    }
}
